
export default {
  uploading: false,
  uploadProgress: 0,
  progressList: [],
}
